import { useEffect, useState } from "react";
import Button from "../../../../Custom/Button/Button";
import sortImg from "../../../../../picture/Sort.png";
import redniBrojeviImg from "../../../../../picture/redniBrojevi.png";
import notifImg from "../../../../../picture/notification.png";
import deleteImg from "../../../../../picture/delete.png";
import archiveImg from "../../../../../picture/letterA.png";
import arrowImg from "../../../../../picture/PlayLanguage.png";
import Filtriranje from "./Filtriranje";
import Dodavanje from "./Dodavanje";
import Preview from "./Preview";
import { useGlobalContext } from "../../../../../Context/Context";
import axios from "axios";
import EyeIcon from "../../../../../picture/Visible.png";

const styles = {
  cell: { padding: "5px", textAlign: "center", fontSize: "14px" },
  smallCell: { width: "30px", textAlign: "center" },
};

function TabelaZaposleni({ currentTab }) {
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentState, setCurrentState] = useState("");
  const [previewId, setPreviewId] = useState(undefined);
  const [editData, setEditData] = useState(null);
  const [isCheckedRedniBrojevi, setIsCheckedRedniBrojevi] = useState(false);
  const [isCheckedSort, setIsCheckedSort] = useState(false);
  const [checkedRows, setCheckedRows] = useState([]);
  const [isCheckedAll, setIsCheckedAll] = useState(false);
  const [lookups, setLookups] = useState({
    zaposleni: [],
    radna_mesta: [],
    lzo: [],
    mere: [],
  });

  const { dictionary, baseUrl, selectedMainEntity } = useGlobalContext();

  const fetchData = async () => {
    try {
      const { data } = await axios.post(`${baseUrl}/evidencija6/read.php`, {
        company_id: selectedMainEntity.company_id,
      });
      if (data.status === 200) {
        setAllData(data.data);
        setFilteredData(data.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const fetchLookups = async () => {
    try {
      const { data } = await axios.post(
        `${baseUrl}/evidencija6/get_lookups.php`,
        {
          company_id: selectedMainEntity.company_id,
        },
      );
      if (data.status === 200) setLookups(data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (!selectedMainEntity?.company_id) return;
    fetchData();
    fetchLookups();
    setCurrentState("");
  }, [selectedMainEntity, currentTab]);

  const handleCheckSort = () => {
    setIsCheckedSort((prev) => !prev);
    setFilteredData((prev) => [...prev].reverse());
  };

  const handleCheckRow = (id) => {
    setCheckedRows((prev) =>
      prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id],
    );
  };

  const handleCheckAll = () => {
    setCheckedRows(isCheckedAll ? [] : filteredData.map((z) => z.id));
    setIsCheckedAll((prev) => !prev);
  };

  const handleDelete = async (id) => {
    try {
      const endpoint =
        currentTab === "ARHIVIRANI" ? "delete.php" : "archive.php";
      await axios.post(`${baseUrl}/evidencija6/${endpoint}`, { id });
      fetchData();
    } catch (e) {
      console.error(e);
    }
  };

  const handlePreview = async (id) => {
    try {
      const { data } = await axios.post(`${baseUrl}/evidencija6/readOne.php`, {
        id,
      });
      if (data.status === 200) {
        setEditData(data.data);
        setPreviewId(id);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleDodaj = () => {
    if (currentTab === "ARHIVIRANI") return;
    setEditData(null);
    setCurrentState("DODAVANJE");
  };

  const cancelPreview = () => {
    setPreviewId(undefined);
    setCurrentState("");
  };
  const handleZatvoriDodavanje = () => {
    setCurrentState("");
    fetchData();
  };

  if (previewId !== undefined)
    return (
      <Preview
        id={previewId}
        cancel={cancelPreview}
        data={editData}
        lookups={lookups}
        onRefresh={fetchData}
      />
    );

  if (currentState === "DODAVANJE")
    return (
      <Dodavanje
        handleZatvori={handleZatvoriDodavanje}
        lookups={lookups}
        sacuvajAzurirano={fetchData}
      />
    );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "90%",
      }}
    >
      <div
        style={{
          overflowY: "auto",
          height: `calc(100% - ${currentState === "FILTRIRANJE" ? "140" : "60"}px)`,
          backgroundColor: "white",
          padding: "5px",
          border: "1.5px solid #9f9f9f",
        }}
      >
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={styles.smallCell}>
                <input
                  type="checkbox"
                  checked={isCheckedAll}
                  onChange={handleCheckAll}
                  style={{ width: "25px" }}
                />
              </th>
              <th style={{ width: "80px" }}>
                <div style={{ display: "flex" }}>
                  <div onClick={handleCheckSort}>
                    <Button active={isCheckedSort}>
                      <img
                        src={sortImg}
                        style={{ width: "40px", height: "30px" }}
                      />
                    </Button>
                  </div>
                  <div onClick={() => setIsCheckedRedniBrojevi((p) => !p)}>
                    <Button active={isCheckedRedniBrojevi}>
                      <img
                        src={redniBrojeviImg}
                        style={{ width: "40px", height: "30px" }}
                      />
                    </Button>
                  </div>
                </div>
              </th>
              <th style={styles.cell}>{dictionary["imeIPrezime"]}</th>
              <th style={styles.cell}>{dictionary["radnoMesto"]}</th>
              <th style={styles.cell}>{dictionary["datum"]}</th>
              <th style={styles.cell}>{dictionary["razlog"]}</th>
              <th style={styles.smallCell}>
                <img src={notifImg} style={{ width: "25px" }} />
              </th>
              <th style={styles.cell}></th>
              <th style={styles.cell}></th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((item, i) => (
              <tr key={item.id}>
                <td style={styles.cell}>
                  <input
                    type="checkbox"
                    checked={checkedRows.includes(item.id)}
                    onChange={() => handleCheckRow(item.id)}
                    style={{ width: "25px" }}
                  />
                </td>
                <td
                  style={styles.cell}
                >{`${isCheckedRedniBrojevi ? item.id : i + 1}.`}</td>
                <td style={styles.cell}>{item.zaposleni_naziv}</td>
                <td style={styles.cell}>{item.radno_mesto_naziv}</td>
                <td style={styles.cell}>{item.teorija_datum}</td>
                <td style={styles.cell}>{item.razlog}</td>
                <td style={styles.cell}>
                  <div
                    style={{
                      width: "25px",
                      height: "25px",
                      backgroundColor:
                        item.status === "ISTEKAO"
                          ? "red"
                          : item.status === "USKORO_ISTICE"
                            ? "orange"
                            : item.status === "NIJE_ISTEKAO"
                              ? "green"
                              : "",
                    }}
                  />
                </td>
                <td
                  onClick={() => handlePreview(item.id)}
                  style={styles.smallCell}
                >
                  <img
                    src={EyeIcon}
                    style={{ width: "30px", cursor: "pointer" }}
                  />
                </td>
                <td
                  onClick={() => handleDelete(item.id)}
                  style={styles.smallCell}
                >
                  <img
                    src={currentTab === "ARHIVIRANI" ? deleteImg : archiveImg}
                    style={{ width: "20px", cursor: "pointer" }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {currentState === "FILTRIRANJE" && (
        <Filtriranje
          setCurrentState={setCurrentState}
          setFilteredData={setFilteredData}
          allData={allData}
          lookups={lookups}
        />
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "20px",
        }}
      >
        <div style={{ fontWeight: "bold", width: "15vw", height: "40px" }}>
          <div style={{ fontSize: "14px" }}>{filteredData.length}</div>
          <div style={{ fontSize: "14px" }}>{dictionary["unos"]}</div>
        </div>
        <div style={{ height: "40px" }}>
          <Button activation={true} style={{ fontWeight: "bold" }}>
            <span style={{ width: "15vw" }}>{dictionary["stampaj"]}</span>
          </Button>
        </div>
        <div style={{ width: "15vw", height: "40px" }}>
          <Button activation={true} style={{ fontWeight: "bold" }}>
            <span style={{ width: "15vw" }}>{dictionary["posalji"]}</span>
          </Button>
        </div>
        <div
          onClick={() =>
            setCurrentState((p) => (p === "FILTRIRANJE" ? "" : "FILTRIRANJE"))
          }
          style={{ width: "15vw", height: "40px" }}
        >
          <Button
            active={currentState === "FILTRIRANJE"}
            style={{ fontWeight: "bold" }}
          >
            <span style={{ width: "15vw" }}>{dictionary["filtriraj"]}</span>
          </Button>
        </div>
        <div onClick={handleDodaj} style={{ width: "15vw", height: "40px" }}>
          {currentTab !== "ARHIVIRANI" && (
            <Button activation={true} style={{ fontWeight: "bold" }}>
              <span style={{ width: "15vw" }}>{dictionary["dodaj"]}</span>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

export default TabelaZaposleni;
